
import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';

import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission } from '@core/objects/form';

import { KeySelectItem } from '@core/models/select-item.model';
import { CoreCustomFormsFiltersService } from '@core/services/custom-forms/custom-forms.service';
import * as CformsSearch from '@core/custom-forms/models/field-search.model';

import { Label } from '@core/objects/label';

@Component({
    selector: 'form-field-fill-multiple-tag-selector-v1',
    templateUrl: './fill-multiple-tag-selector-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FillMultipleTagSelectorV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();

    public placeholder: string = "Choose a tag";
    public items: Array<KeySelectItem> = [];  
    public availableLabels: Array<Label>;
    public selectedTags: Array<Label> = [];
    public valid: boolean = false;

    private subs: Subscription[] = [];

    constructor(private filtersSrv: CoreCustomFormsFiltersService,
        private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.subs.push(
            this.filtersSrv.selectInitializedLabelsFilter().subscribe((initialized: boolean) => {
                if(!initialized)
                    this.filtersSrv.loadLabelsFilter();
            })
        );
        // this.updateMenuItems();
        this.subs.push(
            this.filtersSrv.selectLabels().subscribe((filter: CformsSearch.SearchAvailableFilters) => {
                if(filter && filter.items?.length > 0){                
                    this.availableLabels = filter.items.filter((l:Label) => l.group.id == this.fieldSubmission.field.options.category) as Label[];
                    if(this.fieldSubmission.serialized_value && this.fieldSubmission.serialized_value?.length > 0){
                        this.selectedTags = this.availableLabels.filter((l: Label) => 
                                this.fieldSubmission.serialized_value.some((lval) => l.id.toString() === lval.id.toString()) 
                        );
                        this.valid = this.selectedTags.length !== 0;
                        this.emitValidity();
                    }
                    this.cdr.markForCheck();
                }
            })
        );
    }

    onTagSelect(tag: Label) {
        this.selectedTags = [...this.selectedTags, tag];
        this.valid = this.selectedTags.length > 0 || !this.fieldSubmission.field.mandatory;
        // console.log(" Multiple tag onTagSelect => ",this.valid,tag);
        if(this.valid)
            this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: this.selectedTags.map((l: Label) => l.id)});
        this.emitValidity();
    }

    remove(tag: Label){
        this.selectedTags = this.selectedTags.filter((l: Label) => l.id !== tag.id)
        // if(this.selectedTags.length === 0)
        //     this.valid = false;
        this.valid = this.selectedTags.length > 0 || !this.fieldSubmission.field.mandatory;

        // any way we update:
        this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: this.selectedTags.map((l: Label) => l.id)});
        this.emitValidity();

    }

    private emitValidity(): void {
        this.fieldValidityChange.emit({ id: this.fieldSubmission.field.uuid, valid: this.fieldSubmission.field.mandatory ? this.valid :  true });
    }

}
